module.exports = __webpack_public_path__ + "img/bts-membership-banner.dc58af9d.jpg";